<template>
  <div class="history-module">
    <ul
      v-if="changeList.length"
      class="list"
    >
      <li
        v-for="(item, index) in changeList"
        :key="item.id"
        :class="{ 'active': item.active }"
      >
        <div
          class="item clearfix"
          @click="handleDetail(item, index)"
        >
          <div class="top">
            <div class="addtime">
              <span>{{ item.addtime }}</span>
              <i
                v-if="item.isdetail"
                class="iconfont iconicon-test18 more-btn"
              />
            </div>
            <div class="group">
              <span class="truename">{{ item.truename }}</span>
              <span
                v-if="item.rolename"
                class="rolename fs-gray"
              >[{{ item.rolename }}]</span>
              <span class="type_desc">{{ item.operate }}</span>
              <span v-if="item.userinfo"> ：</span>
            </div>
            <div
              v-if="item.userinfo"
              class="userinfo"
            >
              <span v-if="item.userinfo.before">
                {{ item.userinfo.before.truename }}
                <span class="fs-gray">[
                  <i>{{ item.userinfo.before.rolename }}</i>
                  <i v-if="item.userinfo.before.groupname">/{{ item.userinfo.before.groupname }}</i>]
                </span>
              </span>
              <span v-if="item.userinfo.before"> -> </span>
              <span v-if="item.userinfo.after">
                <!-- 离职交接 -->
                <span v-if="item.type === 16">
                  <span>
                    <!-- 0 共享信息 1 具体到人 3 待指派 2 待分配 -->
                    <i v-if="item.userinfo.after.status === 0">{{ $t('message["394"]') }}</i>
                    <span v-else-if="item.userinfo.after.status === 1">
                      <span>{{ item.userinfo.after.truename }}</span>
                    </span>
                    <i v-else-if="item.userinfo.after.status === 2">{{ $t('message["139"]') }}</i>
                    <i v-else-if="item.userinfo.after.status === 3">{{ $t('message["146"]') }}</i>
                    <i v-else-if="item.userinfo.after.status === 5">{{ $t('message["1460"]') }}</i>
                  </span>
                  <span
                    v-if="item.userinfo.after.rolename"
                    class="fs-gray"
                  >[
                    <i>{{ item.userinfo.after.rolename }}</i>
                    <i v-if="item.userinfo.after.groupname">/{{ item.userinfo.after.groupname }}</i>]
                  </span>
                </span>
                <!-- 其他 -->
                <span v-else>
                  <span>{{ item.userinfo.after.truename }}</span>
                  <span class="fs-gray">[
                    <i>{{ item.userinfo.after.rolename }}</i>
                    <i v-if="item.userinfo.after.groupname">/{{ item.userinfo.after.groupname }}</i>]
                  </span>
                </span>
              </span>
              <span v-else>
                {{ item.userinfo.follow_truename }}
                <span class="fs-gray">[
                  <i>{{ item.userinfo.follow_rolename }}</i>
                  <i v-if="item.userinfo.follow_groupname">/{{ item.userinfo.follow_groupname }}</i>]
                </span>
              </span>
            </div>
            <!-- <span
              v-if="item.isdetail"
              class="detail-btn btn-text fr"
            >
              详情
              <i
                v-show="!item.active"
                class="iconfont iconicon-test19 fs-gray"
              />
              <i
                v-show="item.active"
                class="iconfont iconicon-test73 fs-gray"
              />
            </span> -->
          </div>
          <div
            v-if="item.content"
            class="content"
          >
            {{ item.content }}
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import moment from 'moment'
import eventBus from '@/lib/eventBus'

export default {
  data () {
    return {
      detailId: ''
    }
  },
  computed: {
    ...mapState('inquery/detailData', ['historyList', 'historyDetail']),
    inquiryId () {
      return this.$route.params.inquiryId
    },
    changeList () {
      let { list = [] } = this.historyList || {}

      let newList = list.map(item => {
        if (item.userinfo) {
          if (item.userinfo.before) {
            for (let k in item.userinfo.before) {
              let key = k.split('_') && k.split('_')[1]
              item.userinfo.before[key] = item.userinfo.before[k]
            }
          }
          if (item.userinfo.after) {
            for (let k in item.userinfo.after) {
              let key = k.split('_') && k.split('_')[1]
              item.userinfo.after[key] = item.userinfo.after[k]
            }
          }
          if (!item.userinfo.before && !item.userinfo.after) {
            for (let k in item.userinfo) {
              let key = k.split('_') && k.split('_')[1]
              if (key) {
                item.userinfo[key] = item.userinfo[k]
              }
            }
          }
        }
        return item
      })
      return newList
    }
  },
  async created () {
    await this.getHistoryList()
  },
  methods: {
    moment,
    ...mapActions('inquery/detailData', ['fetchHistoryList', 'fetchHistoryDetail']),
    async getHistoryList () {
      const chain = await this.fetchHistoryList()
      chain
        .params({
          inquiryid: this.inquiryId
        })
        .fetch()
    },
    async handleDetail (item, index) {
      if (!item.isdetail) return

      this.detailId = item.id
      eventBus.$emit('toggleHistoryDetailModal', true, this.detailId)
    }
  }
}
</script>

<style lang="scss" scoped>
.history-module {
  background-color: #fff;
  i,
  em {
    font-style: normal;
  }
  .item {
    padding: 12px;
    border-bottom: solid 1px $gray4;
    .addtime {
      display: flex;
      justify-content: space-between;
      margin-bottom: 12px;
      color: $gray3;
      font-size: 14px;
      .more-btn {
        color: $primary-color;
      }
    }
    .group {
      font-size: 14px;
      line-height: 1.5;
    }
    .rolename {
      margin: 0 4px;
    }
    .userinfo {
      display: block;
      padding: 12px 0;
      line-height: 1.5;
      font-size: 14px;
    }
    .content {
      padding: 12px 0;
      color: $gray2;
      font-size: 14px;
      line-height: 24px;
    }
  }
  li.active + li {
    .item {
      border-top: none;
    }
  }
}
</style>
